const galleryId = 79;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": {"en": ""},
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}

let group = [];

group = ["sh_1764105380.jpg","sh_1713449380.jpg","sh_1498595717.jpg","sh_1829640827.jpg","sh_1741122428.jpg","sh_1741122431.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Closed curettage'));

group = ["sh_1646434045.jpg","sh_1713449374.jpg","sh_1829640575.jpg","sh_1829640584.jpg","sh_1741122191.jpg","sh_1741122182.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Open curettage'));

group = ["sh_1797489919.jpg","sh_1486975724.jpg","sh_1780338605.jpg","sh_1619593153.jpg","sh_1829640824.jpg","sh_1277313850.jpg","sh_1486975733.jpg","sh_1277313838.jpg","sh_1555107800.jpg","sh_1382843969.jpg","sh_1713449437.jpg","sh_1829640845.jpg","sh_1829640842.jpg","sh_129331361.jpg","sh_1741122437.jpg","sh_616331219.jpg","sh_616331243.jpg","sh_1741122434.jpg","sh_1713449440.jpg"];
group.forEach((i) => addItemToGroup(i, '3. Tartar removal'));

group = ["sh_343666964.jpg","sh_204887047.jpg","sh_1737653789.jpg","sh_1732973102.jpg","sh_1732613363.jpg","sh_1608293122.jpg","sh_1667965822.jpg","sh_117892363.jpg","sh_130972478.jpg","sh_1667965831.jpg","sh_1237960759.jpg","sh_776621491.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

group = ["sh_165493616.jpg","sh_1634215894.jpg","sh_176391980.jpg","sh_578733967.jpg","sh_124087642.jpg"];
group.forEach((i) => addItemToGroup(i, 'deleted'));

export default items;
